<div class="draggableTouchCarouselDs__cont" *ngIf="isVisible" [ngStyle]="{ height: height, borderRadius: borderRadius }">
  <div class="draggableTouchCarouselDs__cont__wrapper">
    <div class="draggableTouchCarouselDs__cont__wrapper__slider" #slider>
      <ng-container *ngFor="let image of images; trackBy: trackById">
        <div class="draggableTouchCarouselDs__cont__wrapper__slider__slide" [ngStyle]="{ height: height }">
          <div
            class="draggableTouchCarouselDs__cont__wrapper__slider__slide__image"
            [ngStyle]="{ height: height, transform: 'translate(-' + slidePosition + '%, 0%)' }">
            <app-ds-image
              [width]="'100%'"
              [height]="height"
              [alt]="image"
              [src]="image"
              [size]="imageSize"
              [objectFit]="'cover'"
              [useLoader]="true">
            </app-ds-image>
          </div>
        </div>
      </ng-container>
      <div class="draggableTouchCarouselDs__cont__wrapper__slider__extraContent">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="draggableTouchCarouselDs__pagination">
    <app-ds-pagination
      [type]="paginationType"
      [defaultPage]="currentSlide"
      [autoplay]="autoplay"
      [pages]="images?.length"
      (pageHasChanged)="moveSlide($event)">
    </app-ds-pagination>
  </div>
</div>